import { render } from "./TestPreparationView.vue?vue&type=template&id=7b0cd8de"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__